import { supabase } from '@/lib/supabase';
import { ProjectType } from '@/shared/types/api';

export const getProjectContractors = async ({
  projectId,
  type,
}: {
  projectId: number;
  type: ProjectType;
}) => {
  const query = supabase
    .from('project_contractors')
    .select(
      '*, partner_alias:partner_aliases!inner(*, partner_org:orgs!partner_orga_id(*))',
    );

  if (type === 'project') {
    query.eq('project_id', projectId);
  } else if (type === 'subproject_client') {
    query.eq('subproject_client_view_id', projectId);
  } else if (type === 'subproject_contractor') {
    query.eq('subproject_view_id', projectId);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
};
